import moment from 'moment-timezone'

export const getTimezone = () => moment.tz.guess(true)

export default getTimezone
